import { useState } from "react";
import axios from "axios";
import { toast } from "sonner";
import { KeyRound, Copy, RefreshCw, Loader2, Link2 } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const ProposalCode = ({ prospect, index, onUpdate }) => {
  const [busy, setBusy] = useState(false);
  const code = prospect.proposal_code;
  const link = `${window.location.origin}/proposta/${prospect.id}`;

  const generate = async () => {
    setBusy(true);
    try {
      const { data } = await axios.post(`${API}/prospects/${prospect.id}/proposal-code`);
      onUpdate(data);
      toast.success(code ? "Nuovo codice generato" : "Codice proposta creato");
    } catch (e) {
      toast.error("Generazione codice non riuscita");
    } finally {
      setBusy(false);
    }
  };

  const copy = (text, msg) => {
    navigator.clipboard.writeText(text);
    toast.success(msg);
  };

  const message = `Gentile ${prospect.name},\nla proposta di Nex Studio Design è pronta qui: ${link}\nCodice di accesso personale: ${code}`;

  return (
    <div
      data-testid={`proposal-code-box-${index}`}
      className="mt-3 inline-flex flex-wrap items-center gap-2 rounded-xl border border-dashed border-line px-3 py-2"
    >
      <KeyRound size={13} className="text-ochre" />
      <span className="font-accent text-[9px] uppercase tracking-[0.18em] text-faded">Codice proposta</span>
      {code ? (
        <>
          <span
            data-testid={`proposal-code-value-${index}`}
            className="rounded-md bg-ink px-2.5 py-1 font-mono text-sm tracking-[0.25em] text-bone"
          >
            {code}
          </span>
          <button
            type="button"
            onClick={() => copy(code, "Codice copiato")}
            data-testid={`proposal-code-copy-${index}`}
            aria-label="Copia codice"
            className="flex h-7 w-7 items-center justify-center rounded-full text-stone transition-colors duration-300 hover:text-bone"
          >
            <Copy size={13} />
          </button>
          <button
            type="button"
            onClick={() => copy(message, "Messaggio con link e codice copiato")}
            data-testid={`proposal-code-copy-message-${index}`}
            className="inline-flex items-center gap-1.5 rounded-full border border-line px-3 py-1 font-accent text-[9px] uppercase tracking-[0.16em] text-stone transition-colors duration-300 hover:border-bone/50 hover:text-bone"
          >
            <Link2 size={11} /> Copia link + codice
          </button>
          <button
            type="button"
            onClick={generate}
            disabled={busy}
            data-testid={`proposal-code-regenerate-${index}`}
            aria-label="Rigenera codice"
            className="flex h-7 w-7 items-center justify-center rounded-full text-faded transition-colors duration-300 hover:text-terracotta disabled:opacity-50"
          >
            {busy ? <Loader2 size={13} className="animate-spin" /> : <RefreshCw size={13} />}
          </button>
        </>
      ) : (
        <button
          type="button"
          onClick={generate}
          disabled={busy}
          data-testid={`proposal-code-generate-${index}`}
          className="inline-flex items-center gap-1.5 rounded-full bg-ochre/15 px-3 py-1 font-accent text-[9px] font-semibold uppercase tracking-[0.16em] text-ochre transition-colors duration-300 hover:bg-ochre/25 disabled:opacity-50"
        >
          {busy ? <Loader2 size={11} className="animate-spin" /> : <KeyRound size={11} />} Genera codice
        </button>
      )}
    </div>
  );
};
